import PropTypes from 'prop-types';
import { Container, Modal, ModalHeader, ModalBody, Button } from 'reactstrap';
import React, { Suspense, useState, useEffect } from 'react';
import {
  Redirect, Route, Switch, useHistory,
} from 'react-router-dom';
import {
  AppAside,
  AppHeader,
  AppSidebar,
  AppSidebarFooter,
  AppSidebarForm,
  AppSidebarHeader,
  AppSidebarMinimizer,
  AppSidebarNav,
} from '@coreui/react';
import styled from 'styled-components';
import { useTranslation, withTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux';
import { ToastContainer, toast } from "react-toastify";

import {
  getProfile,
  setCultures,
  getGsModuleActive,
  logoutSuccess,
} from '../../redux/actions/actions';

import routes from '../../routes';
import DefaultAside from './DefaultAside';
import DefaultHeader from './DefaultHeader';
import { axiosGet } from '../../helper/fetch';
import Loading from '../../views/Component/Loading';
import DefaultLayoutDropdownHeader from './DefaultLayoutDropdownHeader';

/** CSS */
import '../../scss/react_sidebar.css';
import logHandling from '../../helper/logHandling';
import { t } from 'i18next';

const DivContainer = styled.div`
  width: 100%;
  height: 25px;
  background-color: #2f353a;
`;

// const Title = styled.div`
//   color: #ffffff96;
//   display: flex;
//   justify-content: center;
//   align-items: center;
// `;

const DefaultLayout = (props) => {
  const dispatch = useDispatch();

  const { t, i18n } = useTranslation();

  const history = useHistory();

  const [loading, setLoading] = useState(true);
  const [modulesId, setModulesId] = useState([]);
  const [navigation, setNavigation] = useState({ items: [] });

  const { userinfo } = useSelector((store) => store.user);

  useEffect(() => {
    (async () => {
      await load();
    })();
  }, []);

  useEffect(() => {
    console.log('userinfo: ', userinfo.userinfo);
  }, [userinfo]);

  // Change to useEffect [something]
  useEffect(() => {
    if (userinfo.userinfo) {
      (async () => {
        logHandling('load modules');
        await loadModules();
      })();
      switch (userinfo.userinfo.culture) {
        case 1:
          i18n.changeLanguage('en');
          break;
        case 2:
          i18n.changeLanguage('es');
          break;
        default:
          i18n.changeLanguage('en');
          break;
      }

    }
  }, [userinfo]);

  const hasPermission = (id) => {
    if (id) {
      return !!modulesId.find((data) => data === id);
    }
    return true;
  };

  const loadingFn = () => (
    <div className="animated fadeIn pt-1 text-center">
      {' '}
      <div className="sk-spinner sk-spinner-pulse"> </div>
    </div>
  );

  const load = async () => {
    logHandling('load from defaultLayout');
    const fromStorage = localStorage.getItem('pimsWebAdmin');
    if (fromStorage) {
      dispatch(getProfile());
      dispatch(setCultures());
      dispatch(getGsModuleActive());
      try {
        const { data } = await axiosGet('api/user/modules-id', 'GET');
        setModulesId(data);
      } catch (err) {
        logHandling(err);
      }
    }
  };

  const loadModules = async () => {
    try {
      const culture = userinfo.userinfo.culture;
      const { data } = await axiosGet(`api/user/modules/${culture}`, 'GET');
      const filteredModules_ = [];
      data.map((data) => {
        if (countChildren(data) > 0) {
          filteredModules_.push(data);
        }
      });
      const navigation_ = {
        items: filteredModules_,
      };
      setNavigation(navigation_);
      setLoading(false);
      logHandling(`loading ${loading}`);
    } catch (err) {
      logHandling(err);
    }
  };

  const countChildren = (modules) => {
    if (!modules.children) {
      return modules.url !== '' ? 1 : 0;
    }
    let cant = 0;
    modules.children.forEach((module) => {
      cant += countChildren(module);
      if (module.url === '') delete module.url;
    });
    return cant;
  };

  const handleTimeout = () => {
    dispatch(logoutSuccess());
  };

  const location = props.location;
  const selectedProps = { history, location };
  return (
    <div>
      {
        (loading /* || !userinfo.userinfo */) ? (<Loading loading />)
          : ( 
            <div className="app">
              <Modal isOpen={userinfo.userinfo.username === "TIMEOUT" ? true : false} size='sm'>
                <ModalHeader className='bg-danger'>{t('Timeout.header')}</ModalHeader>
                <ModalBody>
                  <p>{t('Timeout.message')}</p>
                  <Button className='btn btn-success' onClick={handleTimeout}>{t('Timeout.btn')}</Button>
                </ModalBody>
              </Modal>
              <AppHeader fixed>
                <Suspense fallback={loadingFn}>
                  <DefaultHeader history={history} />
                  <DefaultLayoutDropdownHeader userinfo={userinfo.userinfo} className={props.className} />
                </Suspense>
              </AppHeader>
              <div className="app-body">
                <AppSidebar fixed display="xs">
                  <AppSidebarHeader />
                  <AppSidebarForm />
                  <AppSidebarNav navConfig={navigation} {...selectedProps} />
                  <AppSidebarFooter />
                  <AppSidebarMinimizer />
                </AppSidebar>
                <main className="main">
                  <DivContainer />
                  <Container fluid>
                    <Suspense fallback={loadingFn}>
                      <Switch>
                        {routes.map((route) => {
                          if (route.component && hasPermission(route.id)) {
                            return (
                              <Route
                                key={route.path}
                                path={route.path}
                                exact={route.exact}
                                render={(props) => <route.component {...props} />}
                              />
                            );
                          }
                          return null;
                        })}
                        <Redirect from="/" to="/dashboard" />
                      </Switch>
                    </Suspense>
                    <div className="animated">
                      <ToastContainer
                        position="top-right"
                        autoClose={5000}
                        closeOnClick
                      />
                    </div>
                  </Container>
                </main>

                <div>
                  <AppAside fixed id="entity-nav" className="right-aside">
                    <Suspense fallback={loadingFn}>
                      <DefaultAside />
                    </Suspense>
                  </AppAside>
                </div>
              </div>
            </div>
          )
      }
    </div>
  );
};

DefaultLayout.propTypes = {
  isAuth: PropTypes.bool.isRequired,
};

export default (withTranslation()(DefaultLayout));
